<script lang="ts" setup></script>

<template>
	<Head>
		<Title>Terms</Title>
	</Head>

	<main class="legal">
		<div class="content">
			<h1>Terms</h1>

			<p>
				Welcome to Mimicmo! These terms and conditions ("Terms") govern your use of our website mimicmo.com, our mobile app "Mimicmo", and related services (collectively referred to as the
				"Services"). By accessing or using our Services, you agree to these Terms.
			</p>

			<h2>1. Acceptance of Terms</h2>
			<p>By accessing or using our Services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our Services.</p>

			<h2>2. Use of the Services</h2>
			<p>You must be at least 4 years old to use our Services. By using our Services, you represent and warrant that you are at least 4 years old.</p>

			<h2>3. User Accounts</h2>
			<p>If you create an account with us, you are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>

			<h2>4. Privacy</h2>
			<p>
				Your use of our Services is also governed by our
				<a href="/privacy-policy">Privacy Policy</a>
				, which can be found [link to your privacy policy].
			</p>

			<h2>5. Intellectual Property</h2>
			<p>
				All content, logos, trademarks, and other intellectual property on our Services are owned by or licensed to us. You may not use, reproduce, or distribute any content from our Services
				without our express permission.
			</p>

			<h2>6. User-Generated Content</h2>
			<p>If you submit content to our Services, you grant us a non-exclusive, royalty-free, worldwide, and perpetual license to use, modify, and distribute the content on our Services.</p>

			<h2>7. Prohibited Conduct</h2>
			<p>You agree not to engage in any conduct that:</p>
			<ul>
				<li>Violates these Terms</li>
				<li>Violates any applicable laws or regulations</li>
				<li>Harasses, abuses, or harms others</li>
				<li>Impersonates any person or entity</li>
				<li>Introduces viruses or other harmful code</li>
				<li>Attempts to gain unauthorized access to our Services</li>
			</ul>

			<h2>8. Termination</h2>
			<p>We reserve the right to terminate or suspend your account and access to our Services at our discretion, without notice, for any reason, including if you violate these Terms.</p>

			<h2>9. Changes to Terms</h2>
			<p>
				We may update these Terms from time to time. The date of the latest update will be indicated at the top of this page. Your continued use of our Services after the changes constitutes
				your acceptance of the new Terms.
			</p>

			<h2>10. Limitation of Liability</h2>
			<p>
				To the fullest extent permitted by law, we disclaim all warranties, whether express or implied, and shall not be liable for any indirect, incidental, special, consequential, or
				punitive damages.
			</p>

			<h2>10. Contact Us</h2>
			<p>
				If you have any questions about this Terms or our practices, please contact us at
				<a href="mailto:support@mimicmo.com">contact@mimicmo.com</a>
				.
			</p>
		</div>
	</main>
</template>

<style scoped lang="scss"></style>
